import $ from "jquery";

let openOrClosFormCallMe = () => {
    $('.callme-opener, #home-callme').toggleClass('active');
    $('body').toggleClass('no-scroll');
    $('.site').toggleClass('active-left');

    if ($('.site').hasClass('active-left')){
        $('.site').addClass('active');
    } else {
        $('.site').removeClass('active');
    }
};

$('.callme-opener, .callme-opener-toggle').on('click', function (e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    e.preventDefault();
    openOrClosFormCallMe();
});